<template>
  <div class="qweqwe h-full overflow-y-scroll scroll-styling h-full">
    <LabQuestions :labWorkUUID="$route.params.labWorkUUID" @active="onChildActive" />
  </div>
</template>

<script>
import LabQuestions from '@/components/Tsor/LabQuestions.vue';

export default {
  components: {
    LabQuestions,
  },
  data() {
    return {
      isChildActive: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.isChildActive) {
      if (confirm('Вы уверены, что хотите покинуть эту страницу? Несохранённые данные будут потеряны.')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    onChildActive(val) {
      this.isChildActive = val;
    },
  },
};
</script>

<style scoped>
.container {
  min-height: 100vh;
}
</style>
